import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import SearchDialog from "./SearchDialog";
import useApi from "../../api/hooks/useApi";

// 전역 캐시 (CommonFilterSection과 공유)
const globalCache = {
    vendors: null,
    loading: {
        vendors: false
    }
};

const CompanySearchDialog = ({
  open,
  onClose,
  onSelect,
  initialValue = '',
}) => {
  const { t } = useTranslation();
  const api = useApi();
  const [companies, setCompanies] = useState([]);
  const [loading, setLoading] = useState(false);

  // 회사 데이터 가져오기
  const fetchCompanies = async () => {
    if (globalCache.vendors || globalCache.loading.vendors) return; // 전역 캐시 확인
    
    globalCache.loading.vendors = true;
    setLoading(true);
    try {
      console.log('fetchVendors');
      const response = await api.get('/info/v2/vendor/list');
      if (response.data) {
        globalCache.vendors = response.data;
        setCompanies(response.data);
      }
    } catch (error) {
      console.error('회사 데이터 가져오기 실패:', error);
      // 첨부 이미지의 데이터 구조를 반영한 임시 데이터
      const tempCompanies = [
        { 
          partner_id: 300467, 
          partner_name: 'SUNIN INTERNATIONAL',
          partner_code: 200006,
          partner_group: null,
          specification: null,
          biz_reg_no: '610-88-00348',
          boss_name: '박연선',
          postcode: '05401',
          address1: '서울특별시 강동구 성내동 435-29',
          address2: '서울특별시 강동구 성안로3길 12, 2층 (성내동, 영진빌딩)',
          creator_region: 'indonesia',
          created_by: 'test4454',
          created_at: '2025-03-01T08:56:44.795828'
        },
        { 
          partner_id: 300468, 
          partner_name: 'SHINWON CORPORATION',
          partner_code: 200007,
          partner_group: null,
          specification: null,
          biz_reg_no: '105-81-11908',
          boss_name: '박정주',
          postcode: '04157',
          address1: '서울특별시 마포구 도화동 532',
          address2: '서울특별시 마포구 독막로 328 (도화동)',
          creator_region: 'indonesia',
          created_by: 'test4454',
          created_at: '2025-03-01T09:07:54.460211'
        }
      ];
      globalCache.vendors = tempCompanies;
      setCompanies(tempCompanies);
    } finally {
      globalCache.loading.vendors = false;
      setLoading(false);
    }
  };

  // 다이얼로그가 열릴 때 데이터 로드
  useEffect(() => {
    if (open) {
      // 전역 캐시에서 데이터가 있으면 먼저 설정
      if (globalCache.vendors) {
        setCompanies(globalCache.vendors);
      } else if (!globalCache.loading.vendors) {
        // 캐시에 데이터가 없고 로딩 중이 아니면 API 호출
        fetchCompanies();
      }
    }
  }, [open]);

  const columns = [
    { key: "partner_code", label: t("companies.fields.partner_code") },
    { key: "partner_name", label: t("companies.fields.companyName") }
  ];

  const renderRow = (company, StyledTableRow, BodyCell, handleRowClick) => (
    <StyledTableRow
      key={company.partner_id}
      onClick={() => handleRowClick(company)}
      aria-label={`${company.partner_name} (${company.partner_code || "-"})`}
      tabIndex="0"
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          handleRowClick(company);
        }
      }}
    >
      <BodyCell>{company.partner_code || "-"}</BodyCell>
      <BodyCell>{company.partner_name}</BodyCell>
    </StyledTableRow>
  );

  const customFilter = (data, searchTerm) => {
    // 검색어가 없으면 전체 데이터 반환
    if (!searchTerm || searchTerm.trim() === '') {
      return data;
    }

    const searchTermLower = searchTerm.toLowerCase();
    return data.filter((company) => {
      const partnerCode = company.partner_code?.toString().toLowerCase() || "";
      const partnerName = company.partner_name?.toLowerCase() || "";
      return (
        partnerCode.includes(searchTermLower) ||
        partnerName.includes(searchTermLower)
      );
    });
  };

  return (
    <SearchDialog
      open={open}
      onClose={onClose}
      onSelect={onSelect}
      initialValue={initialValue}
      allData={companies}
      title={t("companies.search")}
      placeholder={t("companies.fields.searchByPartnerCodeOrCompanyName")}
      searchKeys={["partner_code", "partner_name"]}
      columns={columns}
      renderRow={renderRow}
      customFilter={customFilter}
      listTitle={t("companies.list.title")}
      isLoading={loading}
    />
  );
};

export default CompanySearchDialog;